import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Customer } from '../model/customer.model';
import { ApiService } from '../services/api.service';
import { DateChangeBillsDialogComponent } from './date-change-bills-dialog.component';

@Component({
  selector: 'app-date-change',
  templateUrl: './date-change.component.html',
  styleUrls: ['./date-change.component.scss'],
})
export class DateChangeComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'customerId',
    'customerName',
    'customerPhone',
    'areaName',
    'customerAddress',
    'actions',
  ];
  dataSource = new MatTableDataSource<Customer>([]);
  isLoading = false;
  searchValue = '';
  searchBillDate = '';
  searchPaidDate = '';
  isSearching = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private apiService: ApiService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadCustomers();
    this.dataSource.filterPredicate = (data: Customer, filter: string) => {
      const term = filter.trim().toLowerCase();
      return (
        (data.customerId && data.customerId.toString().includes(term)) ||
        (data.customerName && data.customerName.toLowerCase().includes(term)) ||
        (data.customerPhone && data.customerPhone.toString().includes(term))
      );
    };
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadCustomers(): void {
    this.isLoading = true;
    this.apiService.getAllCustomers().subscribe(
      (res: any) => {
        this.dataSource.data = res.customers || [];
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
        this._snackBar.open('Failed to load customers', 'Close', { duration: 3000 });
      }
    );
  }

  applyFilter(value: string): void {
    this.searchValue = value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  searchBills(): void {
    if (!this.searchBillDate && !this.searchPaidDate) {
      this._snackBar.open('Enter a bill date or paid date', 'Close', { duration: 2000 });
      return;
    }
    this.isSearching = true;
    this.apiService.searchBillsByDates(this.searchBillDate, this.searchPaidDate).subscribe(
      (res: any) => {
        this.isSearching = false;
        const bills = res.bills || [];
        if (!bills.length) {
          this._snackBar.open('No bills found', 'Close', { duration: 2000 });
          return;
        }
        this.dialog.open(DateChangeBillsDialogComponent, {
          width: '1100px',
          data: { bills: bills, title: 'Bulk Update Bill Dates' },
        });
      },
      () => {
        this.isSearching = false;
        this._snackBar.open('Search failed', 'Close', { duration: 2000 });
      }
    );
  }

  openBills(customer: Customer): void {
    this.dialog.open(DateChangeBillsDialogComponent, {
      width: '900px',
      data: { customer },
    });
  }

}
